import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  Select,
  Link,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
// import Select from "react-select";
import makeAnimated from "react-select/animated";
import Pagination from "@mui/material/Pagination";
import EllipsisText from "react-ellipsis-text";
import moment from "moment";
import { ExportIcon } from "@shopify/polaris-icons";
import axios2 from "axios";
import Select2 from "react-select";

const WalletPayments = () => {
  const navigate = useNavigate();
  const addEditState = useRef("");
  const perPage = 50;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });
  const handleAddUser = () => {
    navigate("/admin/settings/users-and-permissions/new");
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[{ label: "Email", value: "email" }]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: false,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    pageObject.isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };

  const handleClickRow = (param) => {
    // navigate(`/admin/logs/${param}`);
    // window.open(`/admin/logs/${param}`, "_blank");
  };
  const [isSaving, setIsSaving] = useState(false);
  const [date, setDate] = useState("");
  const handleChangeDate = (newValue) => {
    setDate(newValue);
  };

  // ✅ NEW
  const [usersOptions, setUsersOptions] = useState([]);
  const [userId, setUserId] = useState("all"); // selected user id
  const [selectedDateFrom, setSelectedDateFrom] = useState("");
  const handleChangeDateFrom = (newValue) => {
    setSelectedDateFrom(newValue);
  };
  const [selectedDateTo, setSelectedDateTo] = useState("");
  const handleChangeDateTo = (newValue) => {
    setSelectedDateTo(newValue);
  };
  // ✅ NEW: fetch users for dropdown
  useEffect(() => {
    (async () => {
      try {
        // change endpoint to your real users endpoint
        const res = await axios.get(`/app/users?get_all=1`);
        const users = res.data?.data?.data || res.data?.data || [];

        setUsersOptions([
          { label: "All", value: "all" }, // 👈 ALL option
          ...users.map((u) => ({
            label:
              `${u.first_name || ""} ${u.last_name || ""}`.trim() ||
              u.email ||
              `User #${u.id}`,
            value: String(u.id),
          })),
        ]);
      } catch (e) {
        console.log(e);
        setUsersOptions([]);
      } finally {
      }
    })();
  }, []);

  const handleChangeUser = (newValue) => {
    refBoolPage.current = false;
    setPage(1);
    setUserId(newValue);
  };

  useEffect(() => {
    fetchData();
  }, [
    ts,
    availability,
    queryValue,
    page,
    date,
    userId,
    selectedDateFrom,
    selectedDateTo,
  ]);

  async function fetchData() {
    let responseReports = "";

    try {
      responseReports = await axios.get(
        `/wallet-payments-report?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }${date ? `&date=${date}` : ""}${
          userId !== "all" ? `&user_id=${userId}` : ""
        }${
          selectedDateFrom && selectedDateTo
            ? `&from_date=${selectedDateFrom}&to_date=${selectedDateTo}`
            : ""
        }`,
      );
      console.log("test=", responseReports.data.data.data);
      setPageObject({
        ...pageObject,
        tableItems: responseReports.data.data.data.map((item, index) => [
          <div
            className="clickableDiv2"
            onClick={() => handleClickRow(item.id)}
          >
            {item.id}
          </div>,
          <div
            className="clickableDiv2"
            onClick={() => handleClickRow(item.id)}
          >
            <Link
              monochrome
              onClick={() => window.open(`/admin/users/${item.id}`)}
            >{`${item.first_name ?? ""} ${item.last_name ?? ""}`}</Link>
          </div>,
          <div
            className="clickableDiv2"
            onClick={() => handleClickRow(item.id)}
          >
            {item.email ?? -""}
          </div>,
          <div
            className="clickableDiv2"
            onClick={() => handleClickRow(item.id)}
          >
            {item.financial_data?.beginning_wallet_balance !== null
              ? item.financial_data?.beginning_wallet_balance
              : "-"}
          </div>,
          <div
            className="clickableDiv2"
            onClick={() => handleClickRow(item.id)}
          >
            {item.financial_data?.wallet_topup !== null
              ? item.financial_data?.wallet_topup
              : "-"}
          </div>,
          <div
            className="clickableDiv2"
            onClick={() => handleClickRow(item.id)}
          >
            {item.financial_data?.payments_air !== null
              ? item.financial_data?.payments_air
              : "-"}
          </div>,
          <div
            className="clickableDiv2"
            onClick={() => handleClickRow(item.id)}
          >
            {item.financial_data?.payments_earth !== null
              ? item.financial_data?.payments_earth
              : "-"}
          </div>,
          <div
            className="clickableDiv2"
            onClick={() => handleClickRow(item.id)}
          >
            {item.financial_data?.payments_fire !== null
              ? item.financial_data?.payments_fire
              : "-"}
          </div>,

          <div
            className="clickableDiv2"
            onClick={() => handleClickRow(item.id)}
          >
            {item.financial_data?.payments_water !== null
              ? item.financial_data?.payments_water
              : "-"}
          </div>,
          <div
            className="clickableDiv2"
            onClick={() => handleClickRow(item.id)}
          >
            {item.financial_data?.payments_ether !== null
              ? item.financial_data?.payments_ether
              : "-"}
          </div>,
          <div
            className="clickableDiv2"
            onClick={() => handleClickRow(item.id)}
          >
            {item.financial_data?.payments_events !== null
              ? item.financial_data?.payments_events
              : "-"}
          </div>,
          <div
            className="clickableDiv2"
            onClick={() => handleClickRow(item.id)}
          >
            {item.financial_data?.payments_courses !== null
              ? item.financial_data?.payments_courses
              : "-"}
          </div>,
          <div
            className="clickableDiv2"
            onClick={() => handleClickRow(item.id)}
          >
            {item.financial_data?.end_wallet_balance !== null
              ? item.financial_data?.end_wallet_balance
              : "-"}
          </div>,
        ]),
        isLoading: false,
        isListEmpty: !responseReports.data.data.data.length ? true : false,
        tableTotalPages: responseReports.data.data.total,
      });
    } catch (error) {
      console.log(error);
    }

    // if (!featuresList.length)
    //   try {
    //     responseFeatures = await axios.get(`features`);
    //     setFeaturesList(
    //       responseFeatures.data.data.data.map((item, index) => {
    //         return {
    //           label: item.name,
    //           value: item.id,
    //         };
    //       })
    //     );
    //   } catch (error) {
    //     console.log(error);
    //   }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "Please check your email to see the exported sheet",
  );

  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const refId = useRef(null);
  const [activeVerify, setActiveVerify] = useState(false);
  const handleChangeModalVerify = useCallback((activeVerify) => {
    setActiveVerify(!activeVerify);
    setIsSaving(false);
  }, []);
  const handleYesVerify = () => {
    setIsSaving(true);
    axios
      .post(`/app/users/${refId.current}/verify`)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveVerify(!activeVerify);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const handleExport = () => {
    setIsSaving(true);
    const headers = { Authorization: "Bearer h_YGrV*wAO/EBL1uCh'z!i" };
    axios2
      .get(`${process.env.REACT_APP_BASE_URL}/export/financial-history`, {
        headers,
      })
      .then((result) => {
        setIsSaving(false);
        toggleActive();
      })
      .catch((err) => console.log(err));
  };
  const select2Styles = {
    menuPortal: (base) => ({ ...base, zIndex: 999999 }),
    menu: (base) => ({ ...base, zIndex: 999999 }),
  };
  const selectedUserOption =
    usersOptions.find((o) => o.value === userId) || null;
  return (
    <Page
      title="Wallet Payments"
      fullWidth
      primaryAction={
        <ButtonGroup>
          <Button
            variant="primary"
            onClick={handleExport}
            loading={isSaving}
            icon={ExportIcon}
          >
            Export
          </Button>
        </ButtonGroup>
      }
    >
      <Card padding="0">
        {loadingMarkup}

        {/* <Filters
          queryValue={queryValue}
          queryPlaceholder="Search..."
          filters={filters}
          appliedFilters={appliedFilters}
          onQueryChange={handleFiltersQueryChange}
          onQueryClear={handleQueryValueRemove}
          onClearAll={handleFiltersClearAll}
        /> */}
        <FormLayout>
          <FormLayout.Group condensed>
            <Select2
              options={usersOptions}
              value={selectedUserOption} // ✅ must be the option object
              onChange={(opt) => handleChangeUser(opt?.value || "all")} // ✅ pass value string
              placeholder="Please select"
              isClearable={false}
              menuPortalTarget={document.body} // ✅ TOP LEVEL (outside card/table)
              menuPosition="fixed" // ✅ avoids clipping by parents
              styles={select2Styles}
            />

            {/* <Select
              // isClearable
              // isLoading={isUsersLoading}
              label="Filter by user: "
              options={usersOptions}
              value={userId}
              onChange={handleChangeUser}
              placeholder="Select User"
            /> */}

            <TextField
              // label="Filter by date: "
              value={date}
              onChange={handleChangeDate}
              type="date"
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <TextField
              prefix="From: "
              value={selectedDateFrom}
              onChange={handleChangeDateFrom}
              labelInline
              type="date"
            />
            <TextField
              prefix="To: "
              value={selectedDateTo}
              onChange={handleChangeDateTo}
              labelInline
              type="date"
            />
          </FormLayout.Group>
        </FormLayout>

        <DataTable
          columnContentTypes={["text", "text", "text", "text"]}
          headings={[
            <Text variant="bodyMd" as="p" fontWeight="medium">
              User ID
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Name
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Email
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Beginning Wallet Balance
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Wallet Top up
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Niya
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Earth
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Fire
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Water
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Either
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Event
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Courses
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Wallet Balance End
            </Text>,
          ]}
          rows={pageObject.tableItems}
          verticalAlign="middle"
          increasedTableDensity
          footerContent={
            pageObject.tableItems?.length &&
            `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
          }
          hasZebraStripingOnData
        />
        {emtyState}
        {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <Pagination
              variant="outlined"
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
            />
            {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
          </div>
        )}

        <Modal
          open={activeVerify}
          onClose={handleChangeModalVerify}
          title="Verify User"
          primaryAction={{
            content: "Yes",
            onAction: handleYesVerify,
            loading: isSaving,
          }}
          secondaryActions={[
            {
              content: "No",
              loading: isSaving,
              onAction: handleChangeModalVerify,
            },
          ]}
        >
          <Modal.Section>
            <Text>
              <p>Are you sure you want to verify this user?</p>
            </Text>
          </Modal.Section>
        </Modal>
        {toastMarkup}
      </Card>
    </Page>
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
};

export default WalletPayments;
